import { render, staticRenderFns } from "./product_name.vue?vue&type=template&id=46d45fd4&"
import script from "./product_name.vue?vue&type=script&lang=js&"
export * from "./product_name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports